module.exports = __webpack_public_path__ + "img/Ele2.ad0c9ab0.jpg";